"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubCategory = void 0;
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../../hooks");
var _useTranslations = require("../../../hooks/useTranslations");
var _utils = require("../../../utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SubCategory = ({
  subCategory,
  activeSubCategory,
  handleSubCategoryClick,
  displayArrowIcon = true,
  boldText = true,
  isBestOffers,
  isBrands
}) => {
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const isMobile = (0, _hooks.useIsMobile)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isSubCategoryActive = activeSubCategory === subCategory.url;
  const analyticsData = (0, _react.useCallback)(({
    url,
    index,
    title
  }) => () => {
    if (isBrands) {
      (0, _utils.logUserBrandClick)({
        index: index + 1,
        title,
        url
      });
    } else {
      (0, _utils.logUserClick)(url);
    }
  }, [isBrands]);
  const subCategoryClickHandler = (0, _react.useCallback)(() => {
    handleSubCategoryClick(subCategory.url);
  }, [handleSubCategoryClick, subCategory.url]);
  if (!subCategory.url) {
    return null;
  }
  if (isMobile) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SubCategoryRoot, {
      "data-testid": getTestId(_constants.MOBILE_SUBCATEGORY_ROOT),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SubCategoryListElement, {
        "data-testid": getTestId(_constants.SUBCATEGORY_LIST_ELEMENT),
        onClick: subCategoryClickHandler,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SubCategoryTitle, {
          boldText: boldText,
          href: subCategory.url,
          "data-testid": getTestId(_constants.SUBCATEGORY_LIST_ELEMENT_TITLE),
          onClick: analyticsData({
            url: subCategory.url,
            index: -1,
            title: translations.brands
          }),
          children: isBrands ? translations.brands : subCategory.title
        }), displayArrowIcon ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SubCategoryIconWrapper, {
          isSubCategoryActive: isSubCategoryActive,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowDownThin, {
            fontSize: "inherit"
          })
        }) : null]
      }), isSubCategoryActive ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: subCategory.children.map((segment, index) => segment.url && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SubCategorySegment, {
          isBestOffers: isBestOffers,
          href: segment.url,
          "data-testid": getTestId(_constants.SUBCATEGORY_SEGMENT),
          onClick: analyticsData({
            url: segment.url,
            index,
            title: segment.title
          }),
          children: segment.title
        }, segment.id))
      }) : null]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SubCategoryRoot, {
    "data-testid": getTestId(_constants.DESKTOP_SUBCATEGORY_ROOT),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SubCategoryListElement, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SubCategoryTitle, {
        boldText: boldText,
        href: subCategory.url,
        "data-testid": getTestId(_constants.SUBCATEGORY_LIST_ELEMENT_TITLE),
        onClick: analyticsData({
          url: subCategory.url,
          index: -1,
          title: translations.brands
        }),
        children: isBrands ? translations.brands : subCategory.title
      })
    }), subCategory.children.map((segment, index) => segment.url && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SubCategoryListElement, {
      "data-testid": getTestId(_constants.SUBCATEGORY_LIST_ELEMENT),
      onClick: analyticsData({
        url: segment.url,
        index,
        title: segment.title
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SubCategorySegment, {
        href: segment.url,
        children: segment.title
      })
    }, segment.id))]
  });
};
exports.SubCategory = SubCategory;
